module.exports = __webpack_public_path__ + "media/images/vas_cos_outcome_scale-db637f2a6f3a0c3951fdec3303f4667f.png";